import { render, staticRenderFns } from "./MyApprovals_Loan.vue?vue&type=template&id=07d35b2a"
import script from "./MyApprovals_Loan.vue?vue&type=script&lang=js"
export * from "./MyApprovals_Loan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports